import { renderAccordion_unstable } from '@fluentui/react-accordion';

/**
 * Renders the final JSX of the Accordion component, given the state and context values.
 */
export const renderAccordion = renderAccordion_unstable;
